import Vue from "vue";
import VueResource from "vue-resource";
import * as VueGoogleMaps from "vue2-google-maps";
import App from "./GeoWerft.vue";
import is_consent_google_maps from "./check-consent";

document.addEventListener("DOMContentLoaded", function () {
  // Quick check for logged in.
  if (document.querySelector("body.logged-in")) {
    window.addEventListener("mw_manipulate_images", function (e) {
      fetch(rest_url + "geowerft/v1/reload_content", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce,
        },
        body: JSON.stringify({ posts: e.detail.img_list }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            window.mw_tmp_geo_img_list = data.data;
            dispatchEvent(
              new CustomEvent("mw_reload_images_done", {
                detail: { list: window.mw_tmp_geo_img_list },
                bubbles: true,
              })
            );
          }
        });
    });
  }

  setTimeout(function () {
    // Maybe reload images.
    if (
      document.querySelector(".single-object") &&
      document.querySelector(".js_may_reload_img")
    ) {
      let img_list = [];
      document.querySelectorAll(".js_may_reload_img").forEach((item) => {
        const current_li_post_id = item
          .closest(".single-object")
          .getAttribute("data-id");
        if (current_li_post_id !== "") {
          img_list.push(current_li_post_id);
        }
      });
      fetch(rest_url + "geowerft/v1/reload_content", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce,
        },
        body: JSON.stringify({ posts: img_list }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            for (const [key, value] of Object.entries(data.data)) {
              if (
                document.querySelector(
                  '.single-object[data-id="' + key + '"] img'
                )
              ) {
                document.querySelector(
                  '.single-object[data-id="' + key + '"] img'
                ).src = value;
              }
            }
          }
        });
    }
  }, 2000);
});

const cookie_bot = window.Cookiebot || "";

// Use vue-resource package
Vue.use(VueResource);
if (true === is_consent_google_maps() && "" === cookie_bot && !window.CCM) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: geowerftSettings.google_maps_api_key,
      libraries: "places",
    },
  });
}

// Hier müssen noch Aktionen ausgeführt werden, falls etwas bei den Cookies geändert wird.
window.addEventListener(
  "CookiebotOnConsentReady",
  function (e) {
    if (cookie_bot && true === cookie_bot.consent.marketing) {
      localStorage.setItem("mw_cookie_bot_map_consent", "1");
      sessionStorage.setItem("mw_cookie_bot_map_consent", "1");
    }
    window.addEventListener(
      "CookiebotOnAccept",
      function (e) {
        // Hier eine Endlosschleife vermeiden.
        let tmp_locale_session_consent =
          localStorage.getItem("mw_cookie_bot_map_consent") || "";
        let tmp_session_consent =
          sessionStorage.getItem("mw_cookie_bot_map_consent") || "";
        // Prüfen, mit welcher Speicherung gearbeitet werden kann.
        let current_consent_set_check = tmp_locale_session_consent;
        if ("" === tmp_locale_session_consent && "" !== tmp_session_consent) {
          current_consent_set_check = tmp_session_consent;
        }
        if (current_consent_set_check !== "1") {
          localStorage.setItem("mw_cookie_bot_map_consent", "1");
          sessionStorage.setItem("mw_cookie_bot_map_consent", "1");
          location.reload();
        }
      },
      false
    );

    window.addEventListener(
      "CookiebotOnDecline",
      function (e) {
        localStorage.removeItem("mw_cookie_bot_map_consent");
        sessionStorage.removeItem("mw_cookie_bot_map_consent");
      },
      false
    );
  },
  false
);

window.addEventListener("ccm19WidgetClosed", function (args) {
  // Die Cookie einstellungen haben sich ggf. verändert.
  window.CCM.acceptedEmbeddings.forEach((item) => {
    if ("Google Maps" === item.name) {
      location.reload();
    }
  });
});

if (cookie_bot && true === cookie_bot.consent.marketing) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: geowerftSettings.google_maps_api_key,
      libraries: "places",
    },
  });
}

if (window.CCM) {
  window.CCM.acceptedEmbeddings.forEach((item) => {
    if ("Google Maps" === item.name) {
      Vue.use(VueGoogleMaps, {
        load: {
          key: geowerftSettings.google_maps_api_key,
          libraries: "places",
        },
      });
    }
  });
}

// Filters
Vue.filter("format-price", function (x) {
  return parseFloat(x).toLocaleString("de-DE", {
    minimumSignificantDigits: 3,
  });
});

const MaklerWeftGeoWerft = new Vue({
  el: "#geowerft",
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js